import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ActionBarComponentProps from "../Components/calender";

const MainScanTile4WithDate = ({
  unboundedText,
  DatePlaceholder,
  CommentsPlaceholder,
  button_type,
  dateReceived,
  setDateReceived,
  comments,
  setComments,
  onSubmit
}) => {
  // Redux state
  const { keyboardType } = useSelector(state => state.slice);

  // Local state
  const [showCalender, setShowCalender] = useState(false);

  const onCalenderClick = () => {
    setShowCalender(true);
  }

  const handleKeyUp = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onSubmit();
    }
  };

  return (
    <>
      <div className={"cmt-10 mainScanTile backgroundColor-Type3"}>
        <div className={"backgroundColor-Gradient uperScaner-div"}>
          <div className="uperSD-Text font-large-md pick-locations-title">{unboundedText}</div>
        </div>
        <div className="backgroundColor-Type3 scanner-divWithDate cpt-15 cmb-15">
          {/* Date Section */}
          <div className=" backgroundColor-Type4 scannerInput-4 cmb-15 field" style={{ "width": button_type ? "80%" : "95%" }}>
            <input type={keyboardType}
              autoFocus
              readOnly
              className="backgroundColor-Type4 inputscan"
              onPaste={(e) => {
                e.preventDefault();
                return false;
              }}
              onCopy={(e) => {
                e.preventDefault();
                return false;
              }}
              onKeyUp={handleKeyUp}
              placeholder={DatePlaceholder}
              value={dateReceived}
              onChange={(e) => setDateReceived(e.target.value)}
            />
            <img className="floatRandight" src={process.env.PUBLIC_URL + 'Assets/icons/calendar.png'} alt="calender" onClick={(e) => { onCalenderClick(e); }} />
          </div>
          {/* Comment section */}
          <div className=" backgroundColor-Type4 scannerInput-4 cmb-15 field" style={{ "height": "100%", "padding": "0" }}>
            <textarea type={keyboardType}
              className="backgroundColor-Type4 inputscan" style={{ "height": "100%" }}
              onPaste={(e) => {
                e.preventDefault();
                return false;
              }}
              onCopy={(e) => {
                e.preventDefault();
                return false;
              }}
              placeholder={CommentsPlaceholder}
              inputMode="text"
              onKeyUp={handleKeyUp}
              value={comments}
              onChange={(e) => setComments(e.target.value)}
            />
          </div>
        </div>
      </div>
      {showCalender &&
        <ActionBarComponentProps
          changeValue={dateReceived}
          setShowCalender={setShowCalender}
          setCalenderValue={setDateReceived}
          open={showCalender}
          onClose={() => setShowCalender(false)}
        />
      }
    </>
  )
}

export default MainScanTile4WithDate;
